import { useContext, useCallback } from 'react';
import waitUntil from 'wait-until-promise';
import { DialogContext } from './DialogProvider';

const TIMEOUT_MS = 5000;
const INTERVAL_MS = 100;

export const useDialog = () => {
  const context = useContext(DialogContext);

  const getDialog = useCallback((): HTMLElement | null => document.querySelector('.Dialog'), []);

  const waitForDialog = useCallback(
    () =>
      waitUntil(() => getDialog() != null, TIMEOUT_MS, INTERVAL_MS).then(
        () => getDialog() as HTMLElement
      ),
    [getDialog]
  );

  return {
    ...context,
    waitForDialog
  };
};
